module.exports = __webpack_public_path__ + "img/4.718333f7.jpg";